export default "__VITE_ASSET__BcrpCNIG__"